const MAX_RING_RANGE = 1000;

export const getRangeChecks = (
  startRing: number | undefined,
  endRing: number | undefined,
) => {
  const isRangeDefined = startRing !== undefined && endRing !== undefined;
  const isOrderValid =
    startRing != undefined && endRing != undefined && startRing <= endRing;
  const isInRange =
    startRing != undefined &&
    endRing != undefined &&
    endRing - startRing + 1 <= MAX_RING_RANGE;

  const isRangeValid = isRangeDefined && isInRange && isOrderValid;

  return { isRangeDefined, isOrderValid, isInRange, isRangeValid };
};
